import { ScheduleType } from "@/emails/templates/schedule";

export interface NotificationPreference {
  id: string;
  label: string;
}

export const NOTIFICATION_PREFERENCES: NotificationPreference[] = [
  { id: "appointment-confirmation", label: "Appointment confirmation" },
  { id: "appointment-reminder", label: "Appointment reminder" },
  { id: "appointment-canceled", label: "Canceled appointment" },
  { id: "appointment-rescheduled", label: "Appointment rescheduled" },
  { id: "messages-notifications", label: "Messages notifications" },
];

export const SCHEDULE_TYPE_TO_PREFERENCE_MAP: Record<ScheduleType, string> = {
  appointmentScheduled: "appointment-confirmation",
  appointmentReminder: "appointment-reminder",
  appointmentCanceled: "appointment-canceled",
  appointmentRescheduled: "appointment-rescheduled",
} as const;

export const NO_NOTIFICATIONS = "no-notifications";
